import { useState } from "react";

const usePage = (initPage: number = 0, lstPageInfo: Array<IPageInfo> = []) => {
    const [actualPage, setActualPage] = useState(lstPageInfo.find(x => x.index === initPage) as IPageInfo);
    const [index, setIndex] = useState(initPage);

    const Decrement = () => {
        let pageInfo = lstPageInfo.find(x => x.index === index - 1);
        setActualPage(pageInfo ?? {} as IPageInfo);
        setIndex(index - 1);
        window.scrollTo({ top: 0, behavior: 'smooth'})
    }

    const Increment = () => {
        let pageInfo = lstPageInfo.find(x => x.index === index + 1);
        setActualPage(pageInfo ?? {} as IPageInfo);
        setIndex(index + 1);        
        window.scrollTo({ top: 0, behavior: 'smooth'})
    }

    const ViewPage = (indexNew: number) => {
        setIndex(indexNew);
        let pageInfo = lstPageInfo.find(x => x.index === indexNew);
        setActualPage(pageInfo ?? {} as IPageInfo);         
        window.scrollTo({ top: 0, behavior: 'smooth'})
    }

    return {
        actualPage,
        index,
        Increment,
        Decrement,
        ViewPage
    }
}

export { usePage }